export const text = {
  header: "Careers",
  description:
    "Trastar is a family owned business that has been operating in Richardson, Texas for over 20 years. We are actively recruiting candidates for the below positions to join our team. Click on a posting below to learn more and apply!",
};
